import { useEffect, useRef, useState } from "react";
import { GridHeader } from "../../components/Grid/Grid";
import WebService from "../../utility/WebService";
import HelperService from "../../utility/HelperService";
import PageTitle from "../../components/PageTitle/PageTitle";
import { permissionsInterface } from "../onBoarding/onBoardingTypes";
import { useSelector } from "react-redux";
import { EyeFill, Pencil, Plus, Trash } from "react-bootstrap-icons";
import { toast } from "react-toastify";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import AddInventory from "./AddInventory";
import { Button } from "react-bootstrap";
import API from "../../utility/API-endPoints";
import ExpandableGrid, { ExpandableRow } from "../../components/Grid/ExpandableGrid";
import Select from "react-select";
import PlotDateRangePicker from "../../components/PlotDatePicker/PlotDateRangePicker";
import routePaths from "../../Navigation/routePaths";
import { useNavigate } from "react-router-dom";

const headers: GridHeader[] = [
    {
        title: "Name",
        class: "text-left",
        isSorting: true,
        isAsc: true,
        sortingKey: "name",
    },
    {
        title: "Firm Name",
        class: "text-left",
        isSorting: true,
        isAsc: true,
        sortingKey: "firm_name",
    },
    {
        title: "Phone Number",
        class: "text-left",
        isSorting: true,
        isAsc: true,
        sortingKey: "phone",
    },
    {
        title: "Action",
        class: "text-center freeze-column",
        headerClass: "text-center",
        isSorting: false,
        isFilter: false,
        isFreeze: true,
    },
];

const receiptHeadersRed: GridHeader[] = [
    {
        title: "Supplier",
        class: "text-center",
    },
    {
        title: "Stock",
        class: "text-center",
    },
    {
        title: "Quantity",
        class: "text-center",
    },
    {
        title: "Cost",
        class: "text-center",
    },
    {
        title: "Inventory Date",
        class: "text-center",
    },
    {
        title: "Action",
        class: "text-center freeze-column",
        headerClass: "text-center",
        isSorting: false,
        isFilter: false,
        isFreeze: true,
    }
];

const receiptHeaders: GridHeader[] = [
    {
        title: "Supplier",
        class: "text-center",
    },
    {
        title: "Stock",
        class: "text-center",
    },
    {
        title: "Quantity",
        class: "text-center",
    },
    {
        title: "Inventory Date",
        class: "text-center",
    },
    {
        title: "Action",
        class: "text-center freeze-column",
        headerClass: "text-center",
        isSorting: false,
        isFilter: false,
        isFreeze: true,
    }
]

const Inventory = () => {
    const navigate = useNavigate();
    const token = useSelector((state: any) => state.OnBoardingReducer);
    const nextOffset = useRef<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [rows, setRows] = useState<ExpandableRow[]>([]);
    const [permissions, setPermissions] = useState<permissionsInterface | null>(null);
    const [showDeleteModal, setDeleteModal] = useState<boolean>(false);
    const [showAddAgent, setShowAddAgent] = useState<boolean>(false);
    const [editData, setEditData] = useState<any>({});
    const [agentId, setAgentId] = useState<string>("");
    const [keyword, setKeyword] = useState<string>("");
    const [showHiddenFields, setShowHiddenFields] = useState<boolean>(false);
    const [pressedKeys, setPressedKeys] = useState(new Set());
    const [projectList, setProjectList] = useState<any[]>([]);
    const [isLoadingProject, setIsLoadingProject] = useState<boolean>(false);
    const [vendorList, setVendorList] = useState<any[]>([]);
    const [isLoadingVendor, setIsLoadingVendor] = useState<boolean>(false);
    const [selectedProject, setSelectedProject] = useState<string>("");
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [selectedVendor, setSelectedVendor] = useState<string>("");
    const [headerList, setHeaderList] = useState<GridHeader[]>(receiptHeaders);

    useEffect(() => {
        if (token && token.token && token.permissions && !!token.permissions.length) {
            setPermissions(token.permissions.find((item: any) => item.name === "INVENTORY"));
            !projectList.length && getProjectList();
            !vendorList.length && getVendorList();
        }
    }, [token]);

    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keyup', handleKeyUp);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('keyup', handleKeyUp);
        };
    }, [pressedKeys]);

    useEffect(() => {
        showHiddenFields && getInventoryList(1, "", startDate ?? undefined, endDate ?? undefined);
        setHeaderList(showHiddenFields ? receiptHeadersRed : receiptHeaders);
    }, [showHiddenFields]);

    const getHeader = (data: any) => {
        return (
            <div className="d-flex justify-content-between align-items-center w-100">
                <div className="fw-500">{data.project_name} : {data.address}</div>
            </div>
        );
    };

    const getInventoryList = (offset: number, keyword?: string, startDate?: Date, endDate?: Date, order_by?: string, sort_by?: string) => {
        if (!selectedProject) return;
        nextOffset.current = offset;
        if (nextOffset.current < 0 || isLoading) return;
        nextOffset.current == 0 && setIsLoading(true);
        WebService.getAPI({
            action: `${API.INVENTORY_LIST}?limit=10&offset=${offset}&keyword=${keyword ? keyword : ""
                }&sort_by=${order_by ?? "asc"}&fromDate=${startDate ? encodeURIComponent(startDate.toISOString()) : ""}&toDate=${endDate ? encodeURIComponent(endDate.toISOString()) : ""
                }&project_id=${selectedProject}&vendor_id=${selectedVendor}`,
            body: null,
            is_session: showHiddenFields
        })
            .then((res: any) => {
                setIsLoading(false);
                let data: any[] = [];
                const inventory_raw_data: ExpandableRow[] = [];
                for (let i in res.list) {
                    const inventory_emp: any = { header: getHeader(res.list[i]), isExpand: false, data: [], key: new Date().getTime(), class: "d-flex" };
                    for (let j in res.list[i].inventories) {
                        inventory_emp.data.push(showHiddenFields ? {
                            data: [
                                { value: res.list[i].inventories[j].vendor ? res.list[i].inventories[j]?.vendor?.name : "N/A" },
                                { value: res.list[i].inventories[j].stock ? res.list[i].inventories[j]?.stock?.name : "N/A" },
                                { value: (res.list[i].inventories[j].quantity && res.list[i].inventories[j].unit) ? `${res.list[i].inventories[j]?.quantity} ${res.list[i].inventories[j]?.unit?.name}` : "N/A" },
                                { value: HelperService.getCurrencyFormatter(res.list[i].inventories[j].cost) },
                                { value: HelperService.getFormatedDate(res.list[i].inventories[j].inventory_date) },
                                { value: actionList(res.list[i].inventories[j]) },
                            ]
                        } :
                            {
                                data: [
                                    { value: res.list[i].inventories[j].vendor ? res.list[i].inventories[j]?.vendor?.name : "N/A" },
                                    { value: res.list[i].inventories[j].stock ? res.list[i].inventories[j]?.stock?.name : "N/A" },
                                    { value: (res.list[i].inventories[j].quantity && res.list[i].inventories[j].unit) ? `${res.list[i].inventories[j]?.quantity} ${res.list[i].inventories[j]?.unit?.name}` : "N/A" },
                                    { value: HelperService.getFormatedDate(res.list[i].inventories[j].inventory_date) },
                                    { value: actionList(res.list[i].inventories[j]) },
                                ]
                            });
                    }
                    inventory_raw_data.push(inventory_emp);
                };
                setRows(inventory_raw_data);
            })
            .catch((e) => {
                setIsLoading(false);
            });
    };

    const actionList = (data: any) => {
        return (
            <div className="action-btns">
                {permissions && permissions.can_update && <>
                    <button
                        className="cursor-pointer  btn-edit btn"
                        onClick={() => onEdit(data)}
                    >
                        {" "}
                        <Pencil />{" "}
                    </button>
                </>}
                {permissions && permissions.can_delete && <button
                    onClick={() => onConfirmDelete(data)}
                    className="cursor-pointer btn btn-delete"
                >
                    {" "}
                    <Trash />{" "}
                </button>}
            </div>
        );
    };

    const onEdit = (val: any) => {
        setEditData(val);
        setShowAddAgent(true);
    };

    const onConfirmDelete = (val: any) => {
        setAgentId(val.uuid);
        setDeleteModal(true);
    };

    const onDelete = () => {
        setDeleteModal(false);
        setIsLoading(true);
        WebService.deleteAPI({
            action: `inventory/delete/${agentId}`,
            body: null,
        })
            .then((res: any) => {
                setIsLoading(false);
                toast.success(res.message);
                setAgentId("");
                getInventoryList(1, "", startDate ?? undefined, endDate ?? undefined);
            })
            .catch((e) => {
                setIsLoading(false);
                setAgentId("");
            });
    };

    const onCloseUserModal = (e: boolean) => {
        setShowAddAgent(false);
        setEditData({});
        e && getInventoryList(1, "", startDate ?? undefined, endDate ?? undefined);
    };

    const exportSuppliers = () => {
        WebService.getAPI({
            action: `supplier/export?keyword=${keyword ? keyword : ""}`,
            body: null,
            responseType: 'arraybuffer',
        }).then((response: any) => {
            const url = window.URL.createObjectURL(new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `suppliers_${new Date().toISOString()}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        }).catch((e) => {
            toast.error("Failed to export suppliers");
        });
    };

    const handleKeyUp = (e: any) => {
        const key = e.key.toLowerCase();
        if (pressedKeys.has('control') && pressedKeys.has('alt') && pressedKeys.has('o') && pressedKeys.has('p')) setShowHiddenFields(true);
        setPressedKeys((prev: any) => { const updated = new Set(prev); updated.delete(key); return updated; });
    };

    const handleKeyDown = (e: any) => {
        const key = e.key.toLowerCase();
        setPressedKeys((prev: any) => new Set([...prev, key]));
    };

    const getProjectList = () => {
        setIsLoadingProject(true);
        WebService.getAPI({ action: "get/project/list" })
            .then((res: any) => {
                setProjectList(res.list.map((item: any) => { return { ...item, ...{ value: item.id, label: item.project_name } } }));
                setIsLoadingProject(false);
            })
            .catch((e: any) => { })
            .finally(() => {
                setIsLoadingProject(false);
            });
    };

    const getVendorList = () => {
        setIsLoadingVendor(true);
        WebService.getAPI({ action: "supplier/list" })
            .then((res: any) => {
                setVendorList(res.list.map((item: any) => { return { ...item, ...{ value: item.id, label: item.name } } }));
                setIsLoadingVendor(false);
            }).catch((e: any) => { setIsLoadingVendor(false); })
    };

    return (
        <>
            <AddInventory isShow={showAddAgent} isClose={(e: boolean) => { onCloseUserModal(e); }} data={editData} isRed={showHiddenFields} projectList={projectList} vendorList={vendorList} />
            <DeleteModal isShow={showDeleteModal} close={() => { setDeleteModal(false); }} onDelete={() => { onDelete(); }} />
            {permissions && permissions.can_read && <div className="app-page page-dashboard">
                <div className="d-flex justify-content-between align-items-center  mb-2"> <PageTitle title="Inventory" backArrow={false} active={showHiddenFields} />
                    <div>
                        {permissions && permissions.can_write && <Button className="btn btn-brand-1" onClick={() => { setEditData({}); setShowAddAgent(true); }} >  <Plus size={20} className="ms-1" /> Add Inventory </Button>}
                        {/* {permissions && permissions.can_write && permissions.can_update && <Button className="btn btn-brand-1 ms-2" onClick={() => { exportSuppliers(); }} > <PiExport size={20} className="ms-1" /> Export Inventory </Button>} */}
                        {permissions && permissions.can_read && <Button className="btn btn-brand-1 ms-2" onClick={() => { navigate(routePaths.ROYALTY.path) }} > <EyeFill size={20} className="ms-1" /> View Royalty </Button>}
                    </div>
                </div>
                <div className="table-card">
                    {
                        <div className="row mb-3">
                            <div className="col-3">
                                <Select
                                    className="basic-single w-100"
                                    classNamePrefix="select"
                                    isSearchable={true}
                                    isClearable={true}
                                    options={projectList}
                                    onChange={(e: any) => { setSelectedProject(e ? e.value : ""); }}
                                    value={projectList?.find((option) => option.value === selectedProject)}
                                    placeholder="Select Project"
                                />
                            </div>
                            <div className="col-3">
                                <Select
                                    className="basic-single w-100"
                                    classNamePrefix="select"
                                    isSearchable={true}
                                    isClearable={true}
                                    options={vendorList}
                                    onChange={(e: any) => { setSelectedVendor(e ? e.value : ""); }}
                                    value={vendorList?.find((option) => option.value === selectedVendor)}
                                    placeholder="Select Vendor"
                                />
                            </div>
                            <div className="col-3">
                                <PlotDateRangePicker start_date={startDate} end_date={endDate} onDateChange={(start_date, end_date) => { setStartDate(start_date); setEndDate(end_date); }} />
                            </div>
                            <div className="col-3"> <Button className="btn-brand-1" onClick={() => { getInventoryList(1, "", startDate ?? undefined, endDate ?? undefined) }} >  Search </Button>  </div>
                        </div>
                    }
                    <ExpandableGrid rows={rows} headers={headerList} errorMessage={"No Inventory Found"} ShowLoader={isLoading} />
                </div>
            </div>}
        </>
    );
};

export default Inventory;